<template>
  <div class="text-xs-center">
    <v-dialog v-model="modalProdutoVinculado.open" width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title v-html="modalProdutoVinculado.nome"></v-card-title>
        <v-img v-if="modalProdutoVinculado.img" v-bind:src="modalProdutoVinculado.img"></v-img>
        <v-card-text>
          <div v-html="modalProdutoVinculado.descricao"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="modalProdutoVinculado.open = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="produto" width="500" persistent>
      <!---->
     
        <v-btn class="btn-float-fechar white--text" style="margin-top: 50px; margin-right: 10px;" small fab top absolute right color="#ff0000" @click="$emit('clique-no-botao-cancelar')"><v-icon>close</v-icon></v-btn>
      
      
      <v-card v-if="produto">
        <v-img v-if="produto.doc.img && produto.doc.img.length>0" v-bind:src="produto.doc.img[0]"></v-img>
        <v-card-title class="title grey lighten-3" secondary-title v-html="produto.nome"></v-card-title>
        <v-card-text v-html="produto.descricao"></v-card-text>
        <template v-if="produto.doc.variacao && (!(produto.doc.variacao==false || produto.doc.variacao=='false'))">

          <template v-for="(carac,caracIndex) in produto.doc.variacao.carac">
            <template v-if="carac.tipo==='select'">
               <v-divider></v-divider>
               <v-select v-model="produto.doc.variacao.var[caracIndex]"
                      :label="carac.nome"
                      :items="carac.opcoes"
                      :key="caracIndex"
                    >
                    </v-select>
            </template>
            <template v-else-if="carac.tipo==='radio'">
               <v-divider></v-divider>
                <v-radio-group v-model="produto.doc.variacao.var[caracIndex]" 
                  :mandatory="false" 
                  :label="carac.nome">
                  <template v-for="(opcao, caracIndex) in carac.opcoes">
                    <v-radio v-if="opcao.valor>0" :key="caracIndex" :label="opcao.text +' + R$ '+parseFloat(opcao.valor).toFixed(2).replace('.',',')" :value="opcao.value"></v-radio>
                    <v-radio v-else :key="caracIndex" :label="opcao.text" :value="opcao.value"></v-radio>
                  </template>
                </v-radio-group>
            </template>
          </template>
        </template>
        <template v-if="produto.doc.adicionais">
          <template v-for="(adic,itCkIndex) in produto.doc.adicionais">
            <template v-if="adic.tipo==='multi'">
                <v-divider></v-divider>
                <v-card>
                  <v-card-title v-html="adic.nome+':'" class="py-1 font-weight-bold"></v-card-title>
                  <v-card-text v-if="adic.max || adic.min" class="py-1 caption text-xs-right grey--text">
                    <span v-if="adic.min" v-html="'Mínimo: '+adic.min"></span>
                    <span v-if="adic.max && adic.min"> - </span>
                    <span v-if="adic.max" v-html="'Máximo: '+adic.max"></span>
                  </v-card-text>
                  <v-card-text v-for="(item,indexItem) in adic.itens" class="py-1 adicionais-multi">
                    <v-layout>
                      <v-flex shrink>
                        <div style="width: 140px;">
                          <v-btn icon flat small @click="produto.doc.adicionais[itCkIndex].itens[indexItem].qtd--" v-if="produto.doc.adicionais[itCkIndex].itens[indexItem].qtd">
                            <v-icon  color="">remove</v-icon>
                          </v-btn>
                          <v-btn v-else icon flat small disabled><v-icon color="grey">remove</v-icon></v-btn>
                          <template v-if="!item.produto || item.produto && item.produto.id && parseInt(item.produto.id)>0">
                            <input type="number" v-model="produto.doc.adicionais[itCkIndex].itens[indexItem].qtd" style="max-width: 40px; width: auto; text-align: center;">
                            <v-btn icon color flat small @click="incrementarUmAdiconalMulti(itCkIndex,indexItem)" v-if="!item.produto || (item.produto && item.produto.id)">
                              <v-icon  color="">add</v-icon>
                            </v-btn>
                            <v-btn icon color flat small v-else>
                              <v-icon  color="grey">add</v-icon>
                            </v-btn>
                          </template>
                          <template v-else>
                            <span style="max-width: 40px; padding: 0px 23px 0px 9px; text-align: center;">0</span>
                            <v-btn icon color flat small>
                              <v-icon  color="grey">add</v-icon>
                            </v-btn>
                          </template>
                        </div>
                      </v-flex>
                      <v-flex>
                        <div v-html="'( + R$ '+parseFloat(item.valor).toFixed(2).replace('.',',')+') '+ item.nome" v-if="item.valor && parseFloat(item.valor)>0"></div>
                        <div v-html="item.nome" v-else></div>
                        <div v-if="item.produto && item.produto.id && parseInt(item.produto.id)>0">
                          <v-layout>
                            <v-flex class="text-xs-right">
                              <button class="primary--text" @click="verProdutoVinculado(item.produto.id)">+ Detalhes</button>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
            </template>
            <template v-if="adic.tipo==='check'">
                <v-divider></v-divider>
                <v-card-actions>
                  <template>
                    <v-select v-model="alternativos.check"
                      :label="adic.nome"
                      :items="getOptionsArray(adic.itens,adic.nome)"
                      :key="itCkIndex"
                      multiple
                    >
                    </v-select>
                  </template>
                </v-card-actions>
            </template>
            <template v-else-if="adic.tipo==='select'">
               <v-divider></v-divider>
               <v-select v-model="alternativos.select[itCkIndex]"
                      :label="adic.nome"
                      :items="getOptionsArray(adic.itens,adic.nome)"
                      :key="itCkIndex"
                    >
                    </v-select>
            </template>
            <template v-else-if="adic.tipo==='radio'">
               <v-divider></v-divider>
                <v-radio-group v-model="alternativos.radio[itCkIndex]" 
                  :mandatory="false" 
                  :label="adic.nome">
                  <template v-for="(opcao, itRdIndex) in adic.itens">
                    <v-radio v-if="opcao.valor>0" :key="itRdIndex" :label="opcao.nome +' + R$ '+parseFloat(opcao.valor).toFixed(2).replace('.',',')" :value="{nome: adic.nome+': '+opcao.nome,valor: parseFloat(opcao.valor)}"></v-radio>
                    <v-radio v-else :key="itRdIndex" :label="opcao.nome" :value="{nome: adic.nome+': '+opcao.nome,valor: 0}"></v-radio>
                  </template>
                </v-radio-group>
            </template>
          </template>
        </template>
        <v-divider></v-divider>
        <v-card-actions>
          <template>
              <v-btn icon flat small @click="reduzirQtd()">
                <v-icon  color="error">remove</v-icon>
              </v-btn>
                <input type="number" v-model="quantidade" style="max-width: 40px; width: auto; text-align: center;">
              <v-btn icon color flat small @click="quantidade+=1">
                <v-icon  color="success">add</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
          </template>
          <v-spacer></v-spacer>
          <div v-if="parseFloat(produto.doc.condicao[0].valor)>0" class="font-weight-bold">
            <template v-if="produto.doc.valorantigo && parseFloat(produto.doc.valorantigo)>0 && parseFloat(produto.doc.valorantigo)>parseFloat(produto.doc.condicao[0].valor)">
              <div class="text-decoration-line-through grey--text">De R$ {{parseFloat(produto.doc.valorantigo).toFixed(2).replace('.',',')}}</div>
              <div class="success--text">Por R$ {{parseFloat(produto.doc.condicao[0].valor).toFixed(2).replace('.',',')}}</div>
            </template>
            <div v-else>R$ {{parseFloat(produto.doc.condicao[0].valor).toFixed(2).replace('.',',')}}</div>
          </div>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" block @click="inserirProdutoNoPedido()">Comprar</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn color="secondary" block flat @click="$emit('clique-no-botao-cancelar')">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import jquery from 'jquery';
export default {
  props:['produto','baseUrlApi'],
  data() {
    return {
      quantidade: 1,
      alternativos:{
        check: [],
        select:['','',''],
        radio:[]
      },
      modalProdutoVinculado: {
        open: false,
        id: 0,nome: '',descricao: '', img: ''
      }
    };
  },
  methods:{
    inserirProdutoNoPedido(){
      let contar;
      //console.log(this.itemParaPedido);
      //console.log(this.produto.doc.adicionais);
      for(let i=0;i<this.produto.doc.adicionais.length;i++){
        if(this.produto.doc.adicionais[i].tipo=="multi" && this.produto.doc.adicionais[i].obrigatorio){
          contar = 0;
          //console.log(this.produto.doc.adicionais[i]);
          for(let j=0;j<this.produto.doc.adicionais[i].itens.length;j++){
            contar+=this.produto.doc.adicionais[i].itens[j].qtd;
          }
          //console.log('Contar: '+contar);
          if(this.produto.doc.adicionais[i].max && parseInt(this.produto.doc.adicionais[i].max)<contar){
            alert('Insira no máximo '+this.produto.doc.adicionais[i].max+' Itens no adicional '+this.produto.doc.adicionais[i].nome);
            return;
          }
          if(this.produto.doc.adicionais[i].min && parseInt(this.produto.doc.adicionais[i].min)>contar){
            alert('Insira pelo menos '+this.produto.doc.adicionais[i].min+' Itens no adicional '+this.produto.doc.adicionais[i].nome);
            return;
          }
        }
      }
      //return;
      this.$emit('clique-no-botao-inserir',this.itemParaPedido);
    },
    reduzirQtd(){
      if(this.quantidade>1){
        this.quantidade -=1
      }
    },
    getOptionsArray(itens,nome){
      var retorno = [];
      var i;
      for(i=0;i<itens.length;i++){
        if(itens[i].valor && itens[i].valor>0){
          retorno.push({
            text: itens[i].nome + ' (+ R$ '+parseFloat(itens[i].valor).toFixed(2).replace('.',',')+')',
            value: {nome: nome+': '+itens[i].nome, valor: parseFloat(itens[i].valor)}
          });
        }else{
          retorno.push({
            text: itens[i].nome,
            value: {nome: nome+': '+itens[i].nome, valor: 0}
          });
        }
      }
      return retorno
    },
    incrementarUmAdiconalMulti(itCkIndex,indexItem){
      if(this.produto.doc.adicionais[itCkIndex].tipo=="multi"){
        if(this.produto.doc.adicionais[itCkIndex].max && this.produto.doc.adicionais[itCkIndex].max==this.contarAdicionaisMultiInseridos(this.produto.doc.adicionais[itCkIndex].itens)){
          return;
        }
        this.produto.doc.adicionais[itCkIndex].itens[indexItem].qtd++
      }
    },
    contarAdicionaisMultiInseridos(itens){
      let total = 0;
      for(let i=0;i<itens.length;i++){
        total += itens[i].qtd;
      }
      return total;
    },
    verProdutoVinculado(id){
      if(this.modalProdutoVinculado.id == id){
        this.modalProdutoVinculado.open = true;
        return;
      }
     jquery.get(this.baseUrlApi+'public_negocios/detalhesdeproduto/'+id).then(response =>(this.resposta_verProdutoVinculado(response)));
    },
    resposta_verProdutoVinculado(response){
      if(response.situacao){
        this.modalProdutoVinculado.id = response.dados.id;
        this.modalProdutoVinculado.nome = response.dados.nome;
        this.modalProdutoVinculado.descricao = response.dados.descricao;
        if(response.dados.img){
          this.modalProdutoVinculado.img = response.dados.img;
        }else{
          this.modalProdutoVinculado.img = null;
        }
        this.modalProdutoVinculado.open = true;
      }
    }
  },
  computed:{
    adicionais(){
      this.produto.adicionais
    },
    itemParaPedido(){
      var i;
      var opcionais = [];
      var subtotal = parseFloat(this.produto.doc.condicao[0].valor);
      if(!this.produto.doc.variacao || this.produto.doc.variacao==false || this.produto.doc.variacao=="false"){
        var variacao = false;
      }else{
        var variacao = {ref: this.variacaoSelecionada,value: Array.from(this.produto.doc.variacao.var)};
        /*
        if(this.produto.doc.variacao.estoquepeloproduto){
          variacao.estoquepeloproduto = this.produto.doc.variacao.estoquepeloproduto;
        }
        */
        for(i=0;i<this.produto.doc.variacao.var.length;i++){
          if(parseFloat(this.produto.doc.variacao.var[i].valor)>0){
            if(this.produto.doc.variacao.var[i].val=='alt' && parseFloat(this.produto.doc.variacao.var[i].valor)>subtotal){
              subtotal = parseFloat(this.produto.doc.variacao.var[i].valor);
            }else
            if(this.produto.doc.variacao.var[i].val=='add'){
              subtotal += parseFloat(this.produto.doc.variacao.var[i].valor);
            }
          }
        }
      }
      if(this.alternativos.check){
        for(i=0;i<this.alternativos.check.length;i++){
          subtotal+=this.alternativos.check[i].valor;
          opcionais.push(this.alternativos.check[i]);
        }
      }
      if(this.alternativos.select){
        for(i=0;i<this.alternativos.select.length;i++){
          if(this.alternativos.select[i]){
            subtotal+=this.alternativos.select[i].valor;
            opcionais.push(this.alternativos.select[i]);
          }
        }
      }
      if(this.alternativos.radio){
        for(i=0;i<this.alternativos.radio.length;i++){
          if(this.alternativos.radio[i]){
            subtotal+=this.alternativos.radio[i].valor;
            opcionais.push(this.alternativos.radio[i]);
          }
        }
      }
      for(i=0;i<this.produto.doc.adicionais.length;i++){
        if(this.produto.doc.adicionais[i].tipo=="multi"){
          for(let j=0;j<this.produto.doc.adicionais[i].itens.length;j++){
            if(this.produto.doc.adicionais[i].itens[j].qtd && this.produto.doc.adicionais[i].itens[j].qtd>0){
              let novoOpcional = {};
              novoOpcional.nome = ''+this.produto.doc.adicionais[i].itens[j].qtd+'x '+this.produto.doc.adicionais[i].itens[j].nome;
              novoOpcional.qtd = this.produto.doc.adicionais[i].itens[j].qtd;
              if(this.produto.doc.adicionais[i].itens[j].valor){
                /*
                opcionais.push({
                  nome: ''+this.produto.doc.adicionais[i].itens[j].qtd+'x '+this.produto.doc.adicionais[i].itens[j].nome,
                  valor: this.produto.doc.adicionais[i].itens[j].qtd * parseFloat(this.produto.doc.adicionais[i].itens[j].valor),
                  qtd: this.produto.doc.adicionais[i].itens[j].qtd,
                  produto: null
                });
                */
                novoOpcional.valor = this.produto.doc.adicionais[i].itens[j].qtd * parseFloat(this.produto.doc.adicionais[i].itens[j].valor);
                subtotal+=this.produto.doc.adicionais[i].itens[j].qtd * parseFloat(this.produto.doc.adicionais[i].itens[j].valor);
              }else{
                /*
                opcionais.push({
                  nome: ''+this.produto.doc.adicionais[i].itens[j].qtd+'x '+this.produto.doc.adicionais[i].itens[j].nome,
                  valor: 0,
                  qtd: this.produto.doc.adicionais[i].itens[j].qtd,
                  produto: null
                });
                */
               novoOpcional.valor = 0;
              }
              if(this.produto.doc.adicionais[i].itens[j].produto && this.produto.doc.adicionais[i].itens[j].produto.id){
                novoOpcional.produto = this.produto.doc.adicionais[i].itens[j].produto;
              }else{
                novoOpcional.produto = null;
              }
              opcionais.push(novoOpcional);
            }
          }
        }
      }
      return {
        qtd: this.quantidade,
        nome: this.produto.nome,
        id: this.produto.id,
        valor: parseFloat(this.produto.doc.condicao[0].valor),
        subtotal: subtotal,
        opcionais: opcionais,
        variacao: variacao
      }
    },
    estoqueDaVariacao(){
      /*
      if(this.produto.doc.variacao==false || this.produto.doc.variacao=='false'){
        return false
      }
      var i;
      for(i=0;i<this.estoque[this.produto.id].length;i++){
        if(JSON.stringify(this.estoque[this.produto.id][i].var)==JSON.stringify(this.variacaoSelecionada)){
          return this.estoque[this.produto.id][i].estoque;
        }
      }
      */
      return false
    },
    variacaoSelecionada(){
      if(this.produto.doc.variacao==false || this.produto.doc.variacao=='false'){
        return false
      }
      var i;
      var retorno = [];
      for(i=0;i<this.produto.doc.variacao.var.length;i++){
        retorno.push(this.produto.doc.variacao.var[i].id)
      }
      return retorno;
    }
  }
};
</script>
<style>
.btn-float-fechar{
  z-index: 1!important;
}
.adicionais-multi{
  border-top: 1px solid rgb(248, 246, 246);
}
</style>
